import request from '@/utils/request'

// 组织列表
export function getOrgin(params) {
    return request({
        url: '/console/users',
        method: 'GET',
        params
    })
}

// 添加组织
export function addOrgin(params) {
    return request({
        url: '/console/users',
        method: 'POST',
        data: params
    })
}

// 编辑组织
export function editOrgin(params, id) {
    return request({
        url: '/console/users/' + id,
        method: 'PUT',
        data: params
    })
}

// 删除组织
export function delOrgin(id) {
    return request({
        url: '/console/resources/' + id,
        method: 'DELETE'
    })
}

// 组织用户详情
export function detailOrgin(id) {
    return request({
        url: '/console/users/' + id,
        method: 'GET'
    })
}

// 资源授权
export function handleAuthorize(params, id) {
    return request({
        url: '/console/users/' + id + '/authorize',
        method: 'POST',
        data: params
    })
}

// 资源
export function getResources() {
    return request({
        url: '/console/resources',
        method: 'GET'
    })
}

// 启用
export function isEnabled(params, id) {
    return request({
        url: '/console/users/' + id + '/is-enabled',
        method: 'GET',
        params
    })
}
